/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-14 13:33:50
 */
import Mock from 'mockjs'

export default [
  {
    path: '/api/progressList',
    type: 'get',
    response: config => {
      const responseSuccess = Mock.mock({
        status: 'success',
        data: {
          apply: true,
          apply_audit: '@boolean',
          approve: {
            'pedding|10-40': 10,
            'nopedding|40-60': 10
          },
          'noApprove|40-80': 40,
          approvePeople: {
            'lk|10-50': 10,
            'wk|10-50': 10,
            'gk|10-50': 10,
            'zz|10-50': 10,
            'yx|10-50': 10
          }
        }
      })
      return responseSuccess
    }
  },
  {
    path: '/api/choosePeople',
    type: 'get',
    response: config => {
      const reponseData = Mock.mock({
        status: 'success',
        'data|4-10': [
          {
            id: '@id',
            name: '@cname',
            'group|1': ['小学组', '初中组', '高中组', '大学组'],
            'city': '@city(true)',
            job: '@ctitle',
            'phone': /^1[385][1-9]\d{8}/
          }
        ]
      })
      return reponseData
    }
  }
]



// WEBPACK FOOTER //
// ./src/mocks/modules/progressManege.js